import { render, staticRenderFns } from "./FlightSearchResults.vue?vue&type=template&id=507409b5&scoped=true"
import script from "./FlightSearchResults.vue?vue&type=script&lang=js"
export * from "./FlightSearchResults.vue?vue&type=script&lang=js"
import style0 from "./FlightSearchResults.vue?vue&type=style&index=0&id=507409b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507409b5",
  null
  
)

export default component.exports